import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { makeStyles, useMediaQuery } from "@material-ui/core";
import React from "react";
import { Pagination } from "swiper";
import 'swiper/modules/pagination/pagination.min.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import notAvilable from '../../assets/ClientsImages/userImageNotAvilable.png';
import { getPageSizeForSwiperSlides } from "../../utils/helper";


const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: 'center',
        width: '100%',
    },
    cardContainer: {
        padding: '1rem',
        '& .swiper-pagination': {
            color: '#315CD5',
            marginBottom: '-10px'
        }
    },
    card: {
        [theme.breakpoints.down("xs")]: {
            width: '20rem',
            padding: '0.5rem',
        },
        padding: '1rem',
        margin: '1rem auto 2rem auto',
        width: '20rem',
        textAlign: 'start',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    },
    cardHeader: {
        height: '4rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: "center",
    },
    cardContent: {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        '& > div': {
            flexGrow: 1
        }
    },
    experienceAndLinkedIn: {
        [theme.breakpoints.down("xs")]: {
            gap: '1rem',
        },
        display: 'flex',
        gap: '2rem',
        alignItems: 'center',
        justifyContent: 'space-between',
        '& p': {
            background: '#F3F6FC'
        },
        '& svg': {
            fontSize: '1rem',
            color: '#0e76a8',
            '&:hover': {
                color: '#0f8cc8'
            },
            '&:focus': {
                color: 'pink'
            },
        }
    },
    responsiveCompanyLogo: {
        width: '5rem',
    },
    expertResponsiveImg: {
        width: '8rem',
        height: '8rem',
        borderRadius: '10px'
    }
}))

const OurInstructors = ({ experts }) => {

    const classes = useStyles();

    const isSMScreen = useMediaQuery((theme) => theme.breakpoints.down('xs'));
    const isMDScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));
    let sliderPaginationSize = getPageSizeForSwiperSlides(isSMScreen, isMDScreen, experts?.length);

    return (
        <section className={classes.root}>
            <h1>Meet our Instructors</h1>
            <div className={classes.cardContainer}>
                <Swiper
                    slidesPerView={sliderPaginationSize}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[Pagination]}
                >
                    {
                        experts?.map((expert, idx) => (
                            <SwiperSlide key={(expert.name | '') + idx}>
                                <div className={classes.card}>
                                    <div className={`${classes.cardHeader}`}>
                                        <img src={expert?.companyLogo} className={`${classes.responsiveCompanyLogo}`} />
                                    </div>
                                    <div className={classes.cardContent}>
                                        <img src={expert.photoURL || notAvilable} className={classes.expertResponsiveImg} />
                                        <div>
                                            <div className={classes.experienceAndLinkedIn}>
                                                <p>{expert.experience}</p>
                                                <a target="_blank" href={expert.linkedinProfile}>
                                                    <FontAwesomeIcon icon={faLinkedin} />
                                                </a>
                                            </div>
                                            <div>
                                                <h4>{expert.fullname}</h4>
                                                <p>{expert.title}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
            </div>
        </section>
    )
}

export default OurInstructors;